import { render, staticRenderFns } from "./IconSelector.vue?vue&type=template&id=5b424dd7&scoped=true"
import script from "./IconSelector.vue?vue&type=script&lang=js"
export * from "./IconSelector.vue?vue&type=script&lang=js"
import style0 from "./IconSelector.vue?vue&type=style&index=0&id=5b424dd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b424dd7",
  null
  
)

export default component.exports